<form
  [formGroup]="addEditForm"
  [bitSubmit]="submit"
  bit-dialog
  class="bv-account-dialog bv-emergency-access-dialog"
  [title]="title"
  [loading]="loading"
>
  <ng-container bitDialogContent>
    @if (!editMode) {
      <p class="bv-emergency-access-dialog__desc">{{ "inviteEmergencyContactDesc" | i18n }}</p>
      <bit-form-field class="bv-mat-field tw-w-full">
        <bit-label>{{ "email" | i18n }}</bit-label>
        <input bitInput formControlName="email" appAutofocus />
      </bit-form-field>
    }

    <bit-radio-group
      formControlName="emergencyAccessType"
      [block]="true"
      class="bv-emergency-access-dialog__user-access"
    >
      <bit-label>
        {{ "userAccess" | i18n }}
        <a
          target="_blank"
          rel="noreferrer"
          bitLink
          class="bv-emergency-access-dialog__info-link"
          appA11yTitle="{{ 'learnMoreAboutUserAccess' | i18n }}"
          href="https://bitwarden.com/help/emergency-access/#user-access"
        >
          <i class="bwi bwi-info-circle" aria-hidden="true"></i>
        </a>
      </bit-label>

      <bit-form-control disableMargin>
        <input type="radio" bitRadio [value]="emergencyAccessType.View" id="emergencyTypeView" />
        <bit-label>{{ "view" | i18n }}</bit-label>
        <bit-hint>{{ "viewDesc" | i18n }}</bit-hint>
      </bit-form-control>

      <bit-form-control disableMargin>
        <input
          type="radio"
          bitRadio
          [value]="emergencyAccessType.Takeover"
          id="emergencyTypeTakeover"
        />
        <bit-label>{{ "takeover" | i18n }}</bit-label>
        <bit-hint>{{ "takeoverDesc" | i18n }}</bit-hint>
      </bit-form-control>
    </bit-radio-group>

    <bit-form-field class="bv-mat-field bv-emergency-access-dialog__wait-time">
      <bit-label>{{ "waitTime" | i18n }}</bit-label>
      <bit-select formControlName="waitTime">
        @for (o of waitTimes; track o.value) {
          <bit-option [value]="o.value" [label]="o.name"></bit-option>
        }
      </bit-select>
      <bit-hint>{{ "waitTimeDesc" | i18n }}</bit-hint>
    </bit-form-field>
  </ng-container>

  <ng-container bitDialogFooter>
    <div class="bv-account-dialog__footer">
      @if (editMode) {
        <div class="bv-account-dialog__footer-start">
          <button
            type="button"
            class="bv-account-dialog__icon-btn"
            [attr.aria-label]="'delete' | i18n"
            [disabled]="readOnly"
            (click)="delete()"
          >
            <span class="bv-account-dialog__icon-btn__trash" aria-hidden="true"></span>
          </button>
        </div>
      }
      <div class="bv-account-dialog__footer-end">
        <button
          bitButton
          bitFormButton
          type="button"
          buttonType="secondary"
          class="bv-account-dialog__cancel-btn"
          bitDialogClose
        >
          {{ "cancel" | i18n }}
        </button>
        <button
          bitButton
          bitFormButton
          type="submit"
          buttonType="primary"
          class="bv-account-dialog__save-btn"
          [disabled]="readOnly"
        >
          {{ "save" | i18n }}
        </button>
      </div>
    </div>
  </ng-container>
</form>
